import { Nullable } from '@starsoft/common/interfaces';
import { QueryFunctionContext } from '@tanstack/react-query';
import { AxiosInstance, AxiosResponse } from 'axios';
import { UseKycMeQueryKeyProps } from './props';
import { Kyc } from '@starsoft/common/models';

export async function fetchKycMeByOriginId(
  { queryKey }: QueryFunctionContext<UseKycMeQueryKeyProps>,
  axiosInstance: AxiosInstance,
): Promise<Nullable<Kyc>> {
  const originId: string = queryKey[1];

  const response: AxiosResponse<Kyc> = await axiosInstance.get<Kyc>('/kyc/me', {
    params: {
      originId,
    },
  });

  return response.data;
}
